import { apiClient } from '@/services/authApi';
import { endpoints } from '@/services/endpoints';

/** Tenant option for admin dropdown (TenantsResponse item from GET /api/tenants) */
export interface TenantOption {
  label: string;
  value: string;
}

/**
 * GET /api/tenants - list tenants for admin cross-tenant selection.
 * Admin or superadmin only.
 */
export async function getTenants(): Promise<TenantOption[]> {
  const response = await apiClient.get<TenantOption[]>(endpoints.tenants.list);
  return Array.isArray(response.data) ? response.data : [];
}
